module.exports = __webpack_public_path__ + "static/media/icon-group.53bae0fb.svg";